<div id="inner-create-container" class="create-page container-fluid pb-6">
  <div class="h-100 container">
    <div class="h-100 justify-content-center align-items-center row">
      <div class="col-lg-6">
        <div class="card">
          <h4 class="card-title mt-4">Create An Account</h4>
          <div class="card-body">
            <!-- Forms Section -->
            <form
              [formGroup]="createAcctForm"
              (ngSubmit)="handleSubmit(createAcctForm.value)"
              >
              <div class="row g-3">
                <div class="form-floating col-md-6 mb-3">
                  <input
                    type="text"
                    formControlName="firstName"
                    class="form-control"
                    id="floatingInput"
                    placeholder="Please enter your first name."
                    required
                    />
                    <label for="floatingInput"  class="required">First Name</label>
                    @if (f['firstName'].touched && f['firstName'].invalid) {
                      <div
                        class="alert alert-danger m-1"
                        >
                        @if (
                          f['firstName'].errors &&
                          f['firstName'].errors['required']
                          ) {
                          <div
                            >
                            First Name is required.
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-floating col-md-6 mb-3">
                    <input
                      type="text"
                      formControlName="lastName"
                      class="form-control"
                      id="floatingInput"
                      placeholder="Please enter your last name."
                      required
                      />
                      <label for="floatingInput" class="required">Last Name</label>
                      @if (f['lastName'].touched && f['lastName'].invalid) {
                        <div
                          class="alert alert-danger m-1"
                          >
                          @if (
                            f['lastName'].errors && f['lastName'].errors['required']
                            ) {
                            <div
                              >
                              Last Name is required.
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class="form-group col-md-12 pb-2">
                      <label for="email" class="required">E-mail Address </label>
                      <input
                        formControlName="email"
                        type="email"
                        class="form-control mt-2"
                        id="email"
                        placeholder="Enter Email Address"
                        required
                        />
                        @if (f['email'].touched && f['email'].invalid) {
                          <div
                            class="alert alert-danger m-1"
                            >
                            @if (f['email'].errors && f['email'].errors['required']) {
                              <div
                                >
                                Email is required.
                              </div>
                            }
                            @if (f['email'].errors && f['email'].errors['email']) {
                              <div
                                >
                                The email address must be in xxxxxx&#64;yyyyyy format.
                              </div>
                            }
                          </div>
                        }
                        <!-- <div *ngIf="createAcctForm.get('email').invalid && (createAcctForm.get('email').dirty || createAcctForm.get('email').touched)">
                        <div *ngIf="createAcctForm.get('email').errors.required">Email is required.</div>
                        <div *ngIf="createAcctForm.get('email').errors.email">Invalid email format.</div>
                      </div> -->
                    </div>
                  </div>
                  <div ng-controller="Ctrl as ctrl">
                    <toaster-container
                      toaster-options="{'toaster-id': 1, 'animation-class': 'toast-top-left'}"
                    ></toaster-container>
                    <button
                      ng-click="ctrl.popContainerOne()"
                      type="submit"
                      class="btn submit-btn mt-4"
                      [disabled]="!createAcctForm.valid"
                      >
                      Submit
                    </button>
                    <span
                      ><button
                      type="button"
                      routerLink="/login"
                      class="btn btn-outline-primary cancel-btn mt-4"
                      >
                      Cancel
                    </button></span
                    >
                  </div>
                  <div class="mt-3">
                    <a id="return" routerLink="/login">< to Sign In Page</a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
